import { ServiceApi } from "./Api";
import moment from "moment";
import { PedidoPortalService } from "./PedidoPortal";

export class HistoricoAceiteLGPD {

    PostHistoricoAceiteLGPD(usuario) {
        let ip = "Não foi possível obter IP do usuário";
        let local = "Localização não permitida ou indisponível";

        // Requisição do IP
        const ipPromise = ServiceApi.get('https://api.ipify.org')
            .then(resp => {
                ip = resp?.ip || resp?.data?.ip || resp?.data || resp;
            })
            .catch(() => {
                ip = "Não foi possível obter IP do usuário";
            });

        // Obtenção da localização
        const localPromise = new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const coords = position.coords;
                    local = `Latitude: ${coords.latitude}, Longitude: ${coords.longitude}`;
                    resolve();
                },
                error => {
                    // Erro de permissão, timeout, etc.
                    resolve(); // Continua com o local padrão
                }
            );
        });

        const HistoricoLGPD = 'ACEITE DA POLÍTICA DE PRIVACIDADE DO TZION MYRESULT <br>' +
            `Usuário: ${usuario.Nome} <br>` +
            `Data/Hora: ${moment(new Date()).format("DD/MM/YYYY HH:mm:ss")} <br>` +
            `IP: ${ip} <br>` +
            `Local (Coordenadas): ${local}`;

        const servicePedido = new PedidoPortalService();

        usuario.AcessoDTO.DadosAcesso = HistoricoLGPD;

        localStorage.setItem('AceiteLGPD', 'SIM');

        ServiceApi.post(`api/Portal/PostAceiteLGPD`, usuario.AcessoDTO)
            .then(resp => {
                if (resp !== "") {
                    return alert('Não foi possível confirmar o ACEITE DA POLÍTICA DE PRIVACIDADE DO TZION MYRESULT. Tente novamente ou contate o administrador.');
                }

                localStorage.setItem('AceiteLGPD', 'SIM');

                setTimeout(() => {
                    window.location = "#/portal";
                    window.location.reload();
                }, 500);
            })
            .catch(error => {
                console.log(error);
            });
    }


    ChecarAceiteLGPD() {
        const aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        if (aceiteLGPD === false) {
            sessionStorage.clear();
            window.location.reload();
        }
    }

}